import { Link, useNavigate, useLocation } from 'react-router-dom';
import { Play, Pause, Timer, X } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Card } from '@/components/ui/card';
import { cn } from '@/lib/utils';
import { usePomodoro, formatPomodoroTime } from '@/contexts/PomodoroContext';

export function FloatingPomodoroWidget() {
  const location = useLocation();
  const navigate = useNavigate();
  const { mode, timeLeft, isRunning, totalSeconds, start, pause, reset } = usePomodoro();

  if (location.pathname === '/pomodoro') return null;
  if (mode === 'idle') return null;
  // Hide if paused at full duration (effectively idle)
  if (!isRunning && timeLeft === totalSeconds && mode === 'studying') return null;

  const label =
    mode === 'studying' ? 'Foco' : mode === 'long_break' ? 'Pausa longa' : 'Pausa curta';
  const accent =
    mode === 'studying'
      ? 'text-primary'
      : mode === 'long_break'
      ? 'text-blue-500'
      : 'text-green-500';

  return (
    <Card
      className={cn(
        'fixed z-50 shadow-lg border bg-background',
        'bottom-20 right-4 md:bottom-4',
        'flex items-center gap-3 px-3 py-2'
      )}
    >
      <button
        onClick={() => navigate('/pomodoro')}
        className="flex items-center gap-2 text-left"
        aria-label="Abrir Pomodoro"
      >
        <Timer className={cn('h-4 w-4', accent)} />
        <div className="flex flex-col leading-tight">
          <span className={cn('text-xs font-medium', accent)}>{label}</span>
          <span className="text-base font-bold tabular-nums">{formatPomodoroTime(timeLeft)}</span>
        </div>
      </button>
      <div className="flex items-center gap-1">
        {isRunning ? (
          <Button size="icon" variant="secondary" className="h-8 w-8" onClick={pause} aria-label="Pausar">
            <Pause className="h-4 w-4" />
          </Button>
        ) : (
          <Button size="icon" className="h-8 w-8" onClick={start} aria-label="Continuar">
            <Play className="h-4 w-4" />
          </Button>
        )}
        <Button
          size="icon"
          variant="ghost"
          className="h-8 w-8"
          onClick={reset}
          aria-label="Encerrar"
        >
          <X className="h-4 w-4" />
        </Button>
      </div>
    </Card>
  );
}
